// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.attempts-indicator {
  margin-bottom: 15px;
  padding: 10px 12px;
  background-color: #f8f9fa;
  border-radius: 8px;
  border: 1px solid #e9ecef;
}

.attempts-bar {
  width: 100%;
  height: 6px;
  background-color: #e9ecef;
  border-radius: 3px;
  overflow: hidden;
  margin-bottom: 6px;
}

.attempts-bar-fill {
  height: 100%;
  border-radius: 3px;
  transition: width 0.5s ease, background-color 0.3s ease;
}

.attempts-text {
  display: flex;
  justify-content: space-between;
  font-size: 13px;
  color: #495057;
}

.attempts-remaining {
  font-weight: 600;
  color: #007bff;
}


.error-message {
  padding: 12px 16px;
  background-color: #f8d7da;
  border: 1px solid #f5c6cb;
  border-radius: 8px;
  color: #721c24;
  font-size: 14px;
  margin-bottom: 15px;
  line-height: 1.5;
}

.error-lockout {
  background-color: #fff3cd;
  border-color: #ffeaa7;
  color: #856404;
}

.lockout-timer {
  margin-top: 8px;
  padding-top: 8px;
  border-top: 1px dashed rgba(0,0,0,0.1);
  font-weight: 600;
  font-size: 15px;
  color: #dc3545;
}


.required-star {
  color: #dc3545;
  margin-left: 2px;
}


.login-button.loading {
  background-color: #6c757d;
  cursor: not-allowed;
}

.spinner {
  display: inline-block;
  width: 16px;
  height: 16px;
  border: 2px solid rgba(255,255,255,0.3);
  border-radius: 50%;
  border-top-color: #fff;
  animation: spin 0.8s linear infinite;
  margin-right: 8px;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}

.button-loading {
  display: flex;
  align-items: center;
  justify-content: center;
}


@media (max-width: 480px) {
  .attempts-text {
    flex-direction: column;
    align-items: center;
    gap: 4px;
  }
  
  .error-message {
    font-size: 13px;
    padding: 10px 14px;
  }
}
.login-page {
  min-height: calc(100vh - 90px);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
}

.login-container {
  width: 100%;
  max-width: 440px;
}

.login-header {
  text-align: center;
  margin-bottom: 32px;
}

.login-title {
  font-family: 'IBM Plex Mono', monospace;
  font-size: 2.5rem;
  font-weight: 700;
  color: #121212;
  margin-bottom: 8px;
  line-height: 1.2;
}

.login-subtitle {
  font-family: 'IBM Plex Mono', monospace;
  font-size: 1rem;
  color: #666;
  font-weight: 400;
}

.login-card {
  background: white;
  border-radius: 16px;
  padding: 40px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.1);
  border: 2px solid #121212;
}

.login-form {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.form-group {
  display: flex;
  flex-direction: column;
}

.form-label {
  font-family: 'IBM Plex Mono', monospace;
  font-size: 0.875rem;
  font-weight: 500;
  color: #121212;
  margin-bottom: 8px;
}

.form-input {
  font-family: 'IBM Plex Mono', monospace;
  font-size: 1rem;
  padding: 14px 16px;
  border: 2px solid #e0e0e0;
  border-radius: 8px;
  background: #fafafa;
  transition: all 0.3s ease;
  outline: none;
}

.form-input:focus {
  border-color: #121212;
  background: white;
  box-shadow: 0 0 0 3px rgba(18, 18, 18, 0.1);
}

.form-input:disabled {
  background: #f0f0f0;
  cursor: not-allowed;
  opacity: 0.7;
}

.error-message {
  font-family: 'IBM Plex Mono', monospace;
  color: #dc3545;
  font-size: 0.875rem;
  padding: 12px;
  background: rgba(220, 53, 69, 0.1);
  border-radius: 8px;
  text-align: center;
  border: 1px solid rgba(220, 53, 69, 0.2);
}

.lockout-timer {
  font-weight: 600;
  margin-top: 4px;
  color: #121212;
}

.login-button {
  font-family: 'IBM Plex Mono', monospace;
  font-size: 1rem;
  font-weight: 600;
  padding: 16px;
  background: #121212;
  color: white;
  border: 2px solid #121212;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
  margin-top: 8px;
}

.login-button:hover:not(:disabled) {
  background: #333;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.login-button:active:not(:disabled) {
  transform: translateY(0);
}

.login-button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.button-loading {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.spinner {
  width: 16px;
  height: 16px;
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-radius: 50%;
  border-top-color: white;
  animation: spin 1s ease-in-out infinite;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}

.login-footer {
  display: flex;
  justify-content: center;
  margin-top: 8px;
}

.forgot-password-button {
  font-family: 'IBM Plex Mono', monospace;
  font-size: 0.875rem;
  color: #666;
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px 8px;
  border-radius: 4px;
  transition: all 0.2s ease;
}

.forgot-password-button:hover {
  color: #121212;
  background: rgba(18, 18, 18, 0.05);
}

.login-info {
  text-align: center;
  margin-top: 24px;
  padding: 16px;
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.8);
}

.info-text {
  font-family: 'IBM Plex Mono', monospace;
  font-size: 0.875rem;
  color: #666;
  margin: 0;
}

.info-link {
  font-family: 'IBM Plex Mono', monospace;
  font-size: 0.875rem;
  color: #121212;
  background: none;
  border: none;
  cursor: pointer;
  text-decoration: underline;
  font-weight: 500;
  padding: 0;
  margin: 0;
}

.info-link:hover {
  color: #333;
  text-decoration: none;
}


@media (max-width: 768px) {
  .login-page {
    padding: 16px;
    margin-top: 60px;
  }
  
  .login-title {
    font-size: 2rem;
  }
  
  .login-card {
    padding: 32px 24px;
    border-radius: 12px;
  }
  
  .login-form {
    gap: 20px;
  }
  
  .form-input {
    padding: 12px 14px;
    font-size: 0.95rem;
  }
  
  .login-button {
    padding: 14px;
  }
}

@media (max-width: 480px) {
  .login-container {
    max-width: 100%;
  }
  
  .login-title {
    font-size: 1.75rem;
  }
  
  .login-card {
    padding: 24px 20px;
    border-width: 1.5px;
  }
  
  .login-header {
    margin-bottom: 24px;
  }
  
  .form-input {
    font-size: 0.9rem;
  }
  
  .error-message {
    font-size: 0.8rem;
    padding: 10px;
  }
}

@media (max-width: 360px) {
  .login-page {
    padding: 12px;
  }
  
  .login-card {
    padding: 20px 16px;
  }
  
  .login-title {
    font-size: 1.5rem;
  }
  
  .login-subtitle {
    font-size: 0.875rem;
  }
  
  .form-input {
    padding: 10px 12px;
  }
}


@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.login-container {
  animation: fadeIn 0.4s ease-out;
}`, "",{"version":3,"sources":["webpack://./src/components/login/Login.css"],"names":[],"mappings":";AACA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,uDAAuD;AACzD;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;;AAGA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sCAAsC;EACtC,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;;AAGA;EACE,cAAc;EACd,gBAAgB;AAClB;;;AAGA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,uCAAuC;EACvC,kBAAkB;EAClB,sBAAsB;EACtB,oCAAoC;EACpC,iBAAiB;AACnB;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;;AAGA;EACE;IACE,sBAAsB;IACtB,mBAAmB;IACnB,QAAQ;EACV;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;AACF;AACA;EACE,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,6DAA6D;AAC/D;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,uCAAuC;EACvC,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,uCAAuC;EACvC,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,0CAA0C;EAC1C,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,uCAAuC;EACvC,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,uCAAuC;EACvC,eAAe;EACf,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,2CAA2C;AAC7C;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,uCAAuC;EACvC,cAAc;EACd,mBAAmB;EACnB,aAAa;EACb,kCAAkC;EAClC,kBAAkB;EAClB,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,uCAAuC;EACvC,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,0CAA0C;EAC1C,kBAAkB;EAClB,uBAAuB;EACvB,uCAAuC;AACzC;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,uCAAuC;EACvC,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,kBAAkB;EAClB,oCAAoC;AACtC;;AAEA;EACE,uCAAuC;EACvC,mBAAmB;EACnB,WAAW;EACX,SAAS;AACX;;AAEA;EACE,uCAAuC;EACvC,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,WAAW;EACX,qBAAqB;AACvB;;;AAGA;EACE;IACE,aAAa;IACb,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,aAAa;EACf;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;EACpB;AACF;;;AAGA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,+BAA+B;AACjC","sourcesContent":["\r\n.attempts-indicator {\r\n  margin-bottom: 15px;\r\n  padding: 10px 12px;\r\n  background-color: #f8f9fa;\r\n  border-radius: 8px;\r\n  border: 1px solid #e9ecef;\r\n}\r\n\r\n.attempts-bar {\r\n  width: 100%;\r\n  height: 6px;\r\n  background-color: #e9ecef;\r\n  border-radius: 3px;\r\n  overflow: hidden;\r\n  margin-bottom: 6px;\r\n}\r\n\r\n.attempts-bar-fill {\r\n  height: 100%;\r\n  border-radius: 3px;\r\n  transition: width 0.5s ease, background-color 0.3s ease;\r\n}\r\n\r\n.attempts-text {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  font-size: 13px;\r\n  color: #495057;\r\n}\r\n\r\n.attempts-remaining {\r\n  font-weight: 600;\r\n  color: #007bff;\r\n}\r\n\r\n\r\n.error-message {\r\n  padding: 12px 16px;\r\n  background-color: #f8d7da;\r\n  border: 1px solid #f5c6cb;\r\n  border-radius: 8px;\r\n  color: #721c24;\r\n  font-size: 14px;\r\n  margin-bottom: 15px;\r\n  line-height: 1.5;\r\n}\r\n\r\n.error-lockout {\r\n  background-color: #fff3cd;\r\n  border-color: #ffeaa7;\r\n  color: #856404;\r\n}\r\n\r\n.lockout-timer {\r\n  margin-top: 8px;\r\n  padding-top: 8px;\r\n  border-top: 1px dashed rgba(0,0,0,0.1);\r\n  font-weight: 600;\r\n  font-size: 15px;\r\n  color: #dc3545;\r\n}\r\n\r\n\r\n.required-star {\r\n  color: #dc3545;\r\n  margin-left: 2px;\r\n}\r\n\r\n\r\n.login-button.loading {\r\n  background-color: #6c757d;\r\n  cursor: not-allowed;\r\n}\r\n\r\n.spinner {\r\n  display: inline-block;\r\n  width: 16px;\r\n  height: 16px;\r\n  border: 2px solid rgba(255,255,255,0.3);\r\n  border-radius: 50%;\r\n  border-top-color: #fff;\r\n  animation: spin 0.8s linear infinite;\r\n  margin-right: 8px;\r\n}\r\n\r\n@keyframes spin {\r\n  to { transform: rotate(360deg); }\r\n}\r\n\r\n.button-loading {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n\r\n\r\n@media (max-width: 480px) {\r\n  .attempts-text {\r\n    flex-direction: column;\r\n    align-items: center;\r\n    gap: 4px;\r\n  }\r\n  \r\n  .error-message {\r\n    font-size: 13px;\r\n    padding: 10px 14px;\r\n  }\r\n}\r\n.login-page {\r\n  min-height: calc(100vh - 90px);\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  padding: 20px;\r\n  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);\r\n}\r\n\r\n.login-container {\r\n  width: 100%;\r\n  max-width: 440px;\r\n}\r\n\r\n.login-header {\r\n  text-align: center;\r\n  margin-bottom: 32px;\r\n}\r\n\r\n.login-title {\r\n  font-family: 'IBM Plex Mono', monospace;\r\n  font-size: 2.5rem;\r\n  font-weight: 700;\r\n  color: #121212;\r\n  margin-bottom: 8px;\r\n  line-height: 1.2;\r\n}\r\n\r\n.login-subtitle {\r\n  font-family: 'IBM Plex Mono', monospace;\r\n  font-size: 1rem;\r\n  color: #666;\r\n  font-weight: 400;\r\n}\r\n\r\n.login-card {\r\n  background: white;\r\n  border-radius: 16px;\r\n  padding: 40px;\r\n  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.1);\r\n  border: 2px solid #121212;\r\n}\r\n\r\n.login-form {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 24px;\r\n}\r\n\r\n.form-group {\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n\r\n.form-label {\r\n  font-family: 'IBM Plex Mono', monospace;\r\n  font-size: 0.875rem;\r\n  font-weight: 500;\r\n  color: #121212;\r\n  margin-bottom: 8px;\r\n}\r\n\r\n.form-input {\r\n  font-family: 'IBM Plex Mono', monospace;\r\n  font-size: 1rem;\r\n  padding: 14px 16px;\r\n  border: 2px solid #e0e0e0;\r\n  border-radius: 8px;\r\n  background: #fafafa;\r\n  transition: all 0.3s ease;\r\n  outline: none;\r\n}\r\n\r\n.form-input:focus {\r\n  border-color: #121212;\r\n  background: white;\r\n  box-shadow: 0 0 0 3px rgba(18, 18, 18, 0.1);\r\n}\r\n\r\n.form-input:disabled {\r\n  background: #f0f0f0;\r\n  cursor: not-allowed;\r\n  opacity: 0.7;\r\n}\r\n\r\n.error-message {\r\n  font-family: 'IBM Plex Mono', monospace;\r\n  color: #dc3545;\r\n  font-size: 0.875rem;\r\n  padding: 12px;\r\n  background: rgba(220, 53, 69, 0.1);\r\n  border-radius: 8px;\r\n  text-align: center;\r\n  border: 1px solid rgba(220, 53, 69, 0.2);\r\n}\r\n\r\n.lockout-timer {\r\n  font-weight: 600;\r\n  margin-top: 4px;\r\n  color: #121212;\r\n}\r\n\r\n.login-button {\r\n  font-family: 'IBM Plex Mono', monospace;\r\n  font-size: 1rem;\r\n  font-weight: 600;\r\n  padding: 16px;\r\n  background: #121212;\r\n  color: white;\r\n  border: 2px solid #121212;\r\n  border-radius: 8px;\r\n  cursor: pointer;\r\n  transition: all 0.3s ease;\r\n  margin-top: 8px;\r\n}\r\n\r\n.login-button:hover:not(:disabled) {\r\n  background: #333;\r\n  transform: translateY(-1px);\r\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\r\n}\r\n\r\n.login-button:active:not(:disabled) {\r\n  transform: translateY(0);\r\n}\r\n\r\n.login-button:disabled {\r\n  opacity: 0.6;\r\n  cursor: not-allowed;\r\n}\r\n\r\n.button-loading {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 8px;\r\n}\r\n\r\n.spinner {\r\n  width: 16px;\r\n  height: 16px;\r\n  border: 2px solid rgba(255, 255, 255, 0.3);\r\n  border-radius: 50%;\r\n  border-top-color: white;\r\n  animation: spin 1s ease-in-out infinite;\r\n}\r\n\r\n@keyframes spin {\r\n  to { transform: rotate(360deg); }\r\n}\r\n\r\n.login-footer {\r\n  display: flex;\r\n  justify-content: center;\r\n  margin-top: 8px;\r\n}\r\n\r\n.forgot-password-button {\r\n  font-family: 'IBM Plex Mono', monospace;\r\n  font-size: 0.875rem;\r\n  color: #666;\r\n  background: none;\r\n  border: none;\r\n  cursor: pointer;\r\n  padding: 4px 8px;\r\n  border-radius: 4px;\r\n  transition: all 0.2s ease;\r\n}\r\n\r\n.forgot-password-button:hover {\r\n  color: #121212;\r\n  background: rgba(18, 18, 18, 0.05);\r\n}\r\n\r\n.login-info {\r\n  text-align: center;\r\n  margin-top: 24px;\r\n  padding: 16px;\r\n  border-radius: 8px;\r\n  background: rgba(255, 255, 255, 0.8);\r\n}\r\n\r\n.info-text {\r\n  font-family: 'IBM Plex Mono', monospace;\r\n  font-size: 0.875rem;\r\n  color: #666;\r\n  margin: 0;\r\n}\r\n\r\n.info-link {\r\n  font-family: 'IBM Plex Mono', monospace;\r\n  font-size: 0.875rem;\r\n  color: #121212;\r\n  background: none;\r\n  border: none;\r\n  cursor: pointer;\r\n  text-decoration: underline;\r\n  font-weight: 500;\r\n  padding: 0;\r\n  margin: 0;\r\n}\r\n\r\n.info-link:hover {\r\n  color: #333;\r\n  text-decoration: none;\r\n}\r\n\r\n\r\n@media (max-width: 768px) {\r\n  .login-page {\r\n    padding: 16px;\r\n    margin-top: 60px;\r\n  }\r\n  \r\n  .login-title {\r\n    font-size: 2rem;\r\n  }\r\n  \r\n  .login-card {\r\n    padding: 32px 24px;\r\n    border-radius: 12px;\r\n  }\r\n  \r\n  .login-form {\r\n    gap: 20px;\r\n  }\r\n  \r\n  .form-input {\r\n    padding: 12px 14px;\r\n    font-size: 0.95rem;\r\n  }\r\n  \r\n  .login-button {\r\n    padding: 14px;\r\n  }\r\n}\r\n\r\n@media (max-width: 480px) {\r\n  .login-container {\r\n    max-width: 100%;\r\n  }\r\n  \r\n  .login-title {\r\n    font-size: 1.75rem;\r\n  }\r\n  \r\n  .login-card {\r\n    padding: 24px 20px;\r\n    border-width: 1.5px;\r\n  }\r\n  \r\n  .login-header {\r\n    margin-bottom: 24px;\r\n  }\r\n  \r\n  .form-input {\r\n    font-size: 0.9rem;\r\n  }\r\n  \r\n  .error-message {\r\n    font-size: 0.8rem;\r\n    padding: 10px;\r\n  }\r\n}\r\n\r\n@media (max-width: 360px) {\r\n  .login-page {\r\n    padding: 12px;\r\n  }\r\n  \r\n  .login-card {\r\n    padding: 20px 16px;\r\n  }\r\n  \r\n  .login-title {\r\n    font-size: 1.5rem;\r\n  }\r\n  \r\n  .login-subtitle {\r\n    font-size: 0.875rem;\r\n  }\r\n  \r\n  .form-input {\r\n    padding: 10px 12px;\r\n  }\r\n}\r\n\r\n\r\n@keyframes fadeIn {\r\n  from {\r\n    opacity: 0;\r\n    transform: translateY(10px);\r\n  }\r\n  to {\r\n    opacity: 1;\r\n    transform: translateY(0);\r\n  }\r\n}\r\n\r\n.login-container {\r\n  animation: fadeIn 0.4s ease-out;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
